import { render, staticRenderFns } from "./AddMailDestination.vue?vue&type=template&id=5d8cb07d&scoped=true"
import script from "./AddMailDestination.vue?vue&type=script&lang=js"
export * from "./AddMailDestination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8cb07d",
  null
  
)

export default component.exports